import { useCallback } from 'react'
import { formatResponseError } from '../../utils/format-response-error'
import { useApiActionState } from './useApiActionState'

// TODO: manage swrCacheKeysToBeInvalidated
// TODO: manage cancel token
// eslint-disable-next-line no-unused-vars
export const useApiAction = ({ method, swrCacheKeysToBeInvalidated = [] }) => {
	const { loading, setLoading, error, setError, client } = useApiActionState()

	const action = useCallback(
		async (args = {}) => {
			setLoading(true)

			try {
				const { data } = (await method({ client, ...args })) ?? {}
				setError(undefined)
				setLoading(false)
				return data
			} catch (err) {
				setError(formatResponseError(err))
				setLoading(false)
				throw err
			}
		},
		[client, method, setLoading, setError]
	)

	const clearError = useCallback(() => {
		setError(null)
	}, [setError])

	return { action, loading, error, clearError }
}
